module.exports = __webpack_public_path__ + "static/media/wt_logo.ac8870f3.svg";